export * from './constants';

import { productMap_rare_PROD_expanded } from './RARE_PROD';
import { productMap_rare_STAGING } from './RARE_STAGING';

export const productMap_rare =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? productMap_rare_PROD_expanded
    : productMap_rare_STAGING;
